import { useMemo } from "react";

import { ReportSectionsType } from "@api/graphql/types-and-hooks";
import { PeerReviewField } from "@components/QaReview/PeerReview/peerReview.suggestedEdit";
import { getSortedFieldsByRankOrder } from "@pages/EvaluationDetails/Components/helper";
import { useReportOptional } from "@providers/ReportProvider/useReport";

export const useReviewFields = (): Record<string, PeerReviewField> => {
  const report = useReportOptional()?.report;

  return useMemo(
    () =>
      Object.fromEntries(
        (report?.reportSections?.edges ?? []).flatMap((edge) => {
          const section = edge?.node as ReportSectionsType | undefined;
          if (!section) return [];
          return getSortedFieldsByRankOrder(section).map((field) => [
            field.id,
            {
              id: field.id,
              sectionId: section.id,
              title: field.title ?? "Field",
              content: field.content ?? "",
              realField: field,
            },
          ]);
        }),
      ),
    [report],
  );
};
